<template>
  <section class="ut-p-6 prospect-stage-question">
    <h3 class="question-title">Remove this prospect?</h3>
    <p class="ut-mb-6 ut-text-neutral-400">
      {{ prospect.contact.firstName }} {{ prospect.contact.lastName }}
      {{ topActivity.contactPropertyAddress ? ` - ${$options.filters
          .address(topActivity.contactPropertyAddress)}` : '' }}</p>
    <div>
      <radio-button v-for="btn in answers"
              :key="btn.id"
              :id="btn.id"
              :name="'Remove this prospect'"
              v-model="selectedAnswer"
              :selectedValue="selectedAnswer"
              :radioValue="btn.value">
              {{ btn.label }}</radio-button>
      <span class="error ut-text-sm ut-font-bold"
            v-show="validationError">
            Please select an option</span>
    </div>
    <button @click="confirm()" class="btn btn-green-inverted confirm-btn">Confirm</button>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import RadioButton from '@/components/Forms/RadioButton.vue';
import ProspectStatusType from '@/Mapper/ProspectStatusType';

export default {
  name: 'ProspectStageQuesRemoveProspect',
  components: {
    RadioButton,
  },
  props: {
    prospect: {
      type: Object,
      required: true,
    },
    userid: {
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      selectedAnswer: null,
      validationError: false,
      answers: [
        {
          id: 'remove-prospect-confirm',
          value: 'remove',
          label: 'Yes',
        },
        {
          id: 'remove-prospect-cancel',
          value: 'cancel',
          label: 'Cancel',
        },
      ],
      disabledButtonClick: false,
    };
  },
  computed: {
    ...mapGetters('prospectStore', [
      'topActivity',
    ]),
  },
  created() {},
  methods: {
    ...mapActions('prospectStore', [
      'createStatus',
    ]),
    confirm() {
      if (this.disabledButtonClick) {
        return false;
      }

      if (!this.selectedAnswer) {
        this.validationError = true;
        return false;
      }

      this.disabledButtonClick = true;

      if (this.selectedAnswer === 'remove') {
        // create removed status
        const payload = {
          prospectKey: this.prospect.key,
          statusTypeId: ProspectStatusType.removed,
          creatorUserId: this.userid,
          description: '',
        };
        this.createStatus(payload).catch((error) => {
          this.disabledButtonClick = false;
          console.log(error);
        });
      } else if (this.selectedAnswer === 'cancel') {
        this.$emit('update-view', null, true);
      }

      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/styles/prospect-stage-questions";
</style>
